import React from 'react'
import { Box, Container } from 'pcln-design-system'

export default function AdBanner({
  children
}: {
  children?: React.ReactNode | React.ReactNode[]
}) {
  return (
    <Box py={4} m="auto">
      <Container maxWidth={728}>{children}</Container>
    </Box>
  )
}
